import ModalRoot from './ModalRoot.container';

export default ModalRoot;
